
import permission from './permisson'

export default { permission };



// WEBPACK FOOTER //
// ./src/assets/js/tool.js